<template>
  <div class="fail">
    <div>
      <div>
        <div class="errorLogo">
          <img src="/assets/record_not_found_error.png" />
        </div>
        <div class="bigText red">{{ $t("nofound") }}</div>
      </div>
      <div class="text red" v-html="$t('nofound_details')"></div>
    </div>
    <div class="warn red">
      <div class="">
        <span class="red">{{ $t("gentle") }}</span
        ><span class="line"></span><span v-html="reminderMessage"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    reminderMessage() {
      const link =
        '<span class="white">https://verify.pgslotxaskmebet.com</span>';
      return this.$t("reminder", { link });
    },
  },
};
</script>
